//スマホハンバーガーメニューをクリックしたときの動作
$(".js-sp-menu-button").on("click", function () {
  $(this).toggleClass("is-active");
  $(".header__sp-menu").toggleClass("is-active");
});